import { Fragment } from "react";
import "./WhitelabelNft.css";
import { whitelabelNft } from "../../staticdata";
import whitelabelnftbanner from "../../assets/images/services/nft/whitelabelnftbanner.png";

const WhitelabelNft = () => {
  return (
    <Fragment>
      <section className="whitelabelnft-style">
        <div className="whitelabelnft-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="whitelabelnft-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  White Label NFT Marketplace
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Easily become a frontrunner in the NFT world by availing of
                  Kairaa premium NFT token development services. As a leading
                  NFT token development company, we at Kairaa offer the freedom
                  of customization in developing tokens that allow the inclusion
                  of all necessary features and functionalities depending upon
                  the specific needs of the projects. With our expertise and
                  tailored solutions, you can create unique NFT tokens that
                  stand out in the market and drive the success of your NFT
                  project.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={whitelabelnftbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="whitelabelnft-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">White Label NFT Marketplace </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {whitelabelNft.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="whitelabelnft-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default WhitelabelNft;
